module.exports = __webpack_public_path__ + "static/media/Profile-Moderator-03-Namita-Vikas.f0d3272b.png";